module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_music_instrument_cbecae7481247463adac93a251e88c6a.png";